import Container from "./containers/Container";

const Home = {
    Container,
}

export {Home}